const healthiertogether = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Healthier Together",
      },
      {
        type: "tabs",
        size: "10",
        style: "",
        class: "pr-4",
        children: [
          {
            title: "Healthier Together",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "healthierTogetherTab",
                size: "12",
                style: "",
                class: "p-0",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "12",
                  style: "min-height: calc(100vh - 144px)",
                  class: "pl-3 pt-3",
                  form: {
                    // "text": {
                    // "type": 'ckeditor',
                    // "label": 'Page Description',
                    // "placeholder": 'Enter Description',
                    // "required": true,
                    // "info": false,
                    // "character_count": 1000,
                    // "disabled": false,
                    // "class": '',
                    // "size": "12",
                    // "style": ""
                    // },
                    online_consultation: {
                      type: "toggle",
                      label: "Online Consultation",
                      placeholder: "Online Consultation",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                    email: {
                      type: "text",
                      label: "Email",
                      placeholder: "Enter Email",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                    min_age: {
                      type: "text",
                      label: "Minimum Age",
                      placeholder: "Enter Minimum Age",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "3",
                      style: "",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                    max_age: {
                      type: "text",
                      label: "Maximum Age",
                      placeholder: "Enter Maximum Age",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "3",
                      style: "",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                    days: {
                      type: "ht_days",
                      label: "Days",
                      placeholder: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                    isSomethingElseCondition: {
                      type: "toggle",
                      label: "Something Else condition",
                      hideLabel: false,
                      placeholder: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                    message: {
                      type: "text",
                      label: "Patient Confirmation Message",
                      placeholder: "Enter Patient Confirmation Message",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                      displayOn: "online_consultation",
                      displayOnValue: "true",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { healthiertogether };
